import LoaderState from "./loader/initialState";
import LoaderActionTypes from "./loader/actionTypes";

const reducers = {
  loader: function (state = LoaderState, action) {
    switch (action.type) {
      case LoaderActionTypes.SHOW_LOADER:
        return { ...state, loading: action.payload };
      default:
        return state;
    }
  },
};

export default reducers;
